import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { checkNullAndReturnString, doGetConnectSecurity } from '../../helper/common';
import { withStore } from '../../component/hooks/store';
import { withStyles } from '@material-ui/core/styles';
import Styles from "../../styles/admin/agents";
// import Button from "../../component/button";
import Config from '../../helper/config';
import PopOver from "../../component/popOver";
import PhoneInput from 'react-phone-input-2';

class AgentRejected extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            total: 0,
            sortBy: "",
            order: "asc"
        }
    }

    componentDidMount = async () => {
        this.getAgentPendingList(this.state.sortBy, this.state.order);
    }

    getAgentPendingList = async (sortBy, order) => {
        var accessToken = localStorage.getItem("accessToken");
        var responseData = await doGetConnectSecurity("users?id=&status=&roleId=3&name=&skip=&take=&order="+order+"&sortby="+sortBy+"&userAccessStatus=rejected", accessToken)
        if (checkNullAndReturnString(responseData)) {
            this.setState({ total: responseData.total })
            if (checkNullAndReturnString(responseData.data)) {
                this.setState({ list: responseData.data })
            }
        }
    }

    render() {
        var { list, total } = this.state
        const { classes } = this.props;
        var contentData = [];
        if (checkNullAndReturnString(list)) {
            Object.keys(list).forEach(key => {
                var item = list[key];
                contentData.push(
                    <div>
                        <div style={{ paddingTop: 10 }}></div>
                        <div className={classes.border} ></div>
                        <div class="row" >
                            <div class="col" style={{ maxWidth: 100, paddingTop: 12, alignSelf: "center", textAlign: "center" }}>
                                {
                                    checkNullAndReturnString(item.profile_image_hash) ?
                                        <img className={classes.personImage} alt="personimagefirst" src={Config.dataUrl + "aws-files/" + item.profile_image_hash} />
                                        :
                                        <img className={classes.personImage} alt="personimagesecond" src={Config.emptyUser} />
                                }
                            </div>
                            <div class="col" style={{ paddingTop: 12, alignSelf: "center" }}>
                                <span className={classes.playerName}> {item.first_name} {item.last_name} </span>
                            </div>
                            <div class="col" style={{ paddingTop: 12 }}>
                                <span className={classes.player}> Agency </span>
                                <br />
                                <span className={classes.playerName}> {item.agency_name} </span>
                            </div>
                            <div class="col" style={{ paddingTop: 12 }}>
                                <span className={classes.player}> Years Active </span>
                                <br />
                                <span className={classes.playerName}> {item.experience} Years</span>
                            </div>
                            <div class="col" style={{ paddingTop: 12 }}>
                                <span className={classes.player}> Phone Number </span>
                                <br />
                                <span className={classes.playerName}>
                                    {
                                         item.phoneNumber ? <PhoneInput
                                         inputClass={"labelPhoneAgent"}
                                         country={'us'}
                                         inputStyle={{ width: "100%",
                                         background: "transparent",
                                         border: "transparent",
                                         color: "white",
                                      }}
                                      containerStyle={{
                                         background: "transparent",
                                         border: "transparent",
                 
                                      }}
                                      buttonStyle={{
                                          display: "none"
                                      }}
                                      disabled
                                         value={item.phoneNumber}
                                         /> : ""
                                     }
                                </span>
                            </div>
                            <div class="col" style={{ paddingTop: 12 }}>
                                <span className={classes.player}> Location </span>
                                <br />
                                <span className={classes.playerName}> {item.city}, {item.state} </span>
                            </div>                            
                            <div class="col" style={{ alignSelf: "center", paddingTop: 12 }}>
                                <Link to={Config.reactUrl + "/admin/viewagentdetail/" + item.id}>
                                    <a href="#/" className={classes.link} > View Details </a>
                                </Link>
                            </div>
                        </div>
                    </div>
                )
            })
        }
        return (
            <React.Fragment>
                <div class="col-xl-11 col-lg-11 col-md-12 col-sm-12 col-12" >
                    <span style={{ position: "absolute", border: "1px solid #3B3E50", width: 0, height: window.innerHeight / 1.3, whiteSpace: "nowrap" }}></span>
                    <div class="row">
                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12" style={{ paddingLeft: 40 }}>
                            <span className={classes.agentCountText}>{total} Agents Rejected</span>
                        </div>
                        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 " style={{ padding: 10 }}>
                            <PopOver 
                            sortby={"Name"}
                            arrayList={[{ label: 'Name', value: 'first_name' }, { label: 'Agency', value: 'agency_name' }]}
                            onchange={(value)=> {
                                var order = "asc";
                                if (this.state.sortBy === value) {
                                    order = "desc";
                                }
                                this.setState({ sortBy: value, order: order });
                                this.getAgentPendingList(value, order)
                            }}
                            />
                        </div>
                    </div>
                    <div style={{ paddingLeft: 20 }}>
                        {
                            contentData
                        }
                        <div style={{ paddingTop: 10 }}></div>
                        <div className={classes.border} ></div>
                        {
                            Object.keys(contentData).length === 0 ?
                                <p className={classes.agentCountText} style={{ textAlign: "center" }}>
                                    <br />
                                    No Records Found
                                </p>
                                :
                                ""
                        }
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default withStyles(Styles, { withTheme: true })(withStore(AgentRejected));